// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 763 ? "7795b455" : chunkId) + "-" + {"13":"8aea5b30e0618e43","54":"f217b23204b30203","763":"53667e0e30258655"}[chunkId] + ".js";
};